import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AcceleratorCourseAssignment, LanguageId } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<AcceleratorCourseAssignment, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'FullName', row => row.name, { header: 'Accelerator' }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.facilitatorStaffId), { header: 'Program Facilitator Name' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language' }),
		buildColumn(util, 'Id', row => row.courseVersionId, { header: 'courseVersionId', hidden: true }),
		buildColumn(util, 'Number', row => row.version, { header: 'Version' }),
		buildColumn(util, 'Text', row => row.title, { header: 'Title' }),
		buildColumn(util, 'YesNo', row => row.latestVersion, { header: 'Latest Version', hidden: true }),
		buildColumn(util, 'YesNo', row => row.classEventsGenerated, { header: 'Class Events Generated' }),
		buildColumn(util, 'Number', row => row.entrepreneurs, { header: 'Entrepreneurs' }),
		buildColumn(util, 'Number', row => row.enrolled, { header: 'Enrolled' }),
		buildColumn(util, 'Number', row => row.notEnrolled, { header: 'Not Enrolled', hidden: true }),
		buildColumn(util, 'Text', row => row.meetingLocalDisplayText, { header: 'Meeting Time (local time)', headerTooltip: 'Time is shown in the time zone of your current location' }),
		buildColumn(util, 'Text', row => row.meetingAcceleratorDisplayText, { header: 'Meeting Time (accelerator time)', headerTooltip: 'Time is shown in the time zone of the accelerator', hidden: true }),
		buildColumn(util, 'Text', row => row.gravityLocation, { header: 'Gravity Location' }),
		buildColumn(util, 'Text', row => row.gravityZip.toString().padStart(5, '0'), { header: 'Gravity Zip' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}
